// extracted by mini-css-extract-plugin
export default {"container":"TopNav_container__ItQwI","link":"TopNav_link__UX+Oi","gallery":"TopNav_gallery__57fX1","logo":"TopNav_logo__af8Ea","biggest_wood":"TopNav_biggest_wood__63yp9"};